import React from 'react';

const ImageList = () => {
    const originalUrl = 'https://cdn.javisx.com/image/22c0e143-c21a-4b44-9259-93e793175356.png';
    
    // เปลี่ยน path จาก .png เป็น /public
    const updatedUrl = originalUrl.replace('.png', '/public');

    return (
        <div>
            <h1>Image with Updated Path</h1>
            <img src={updatedUrl} alt="Updated Resource" style={{ width: '300px', height: 'auto' }} />
        </div>
    );
};

export default ImageList;